export const PITCH_CUSTOMER_LANG_OPTIONS = Object.freeze([
  { value: "AR", label: "Arabic", labelNative: "العربية" },
  { value: "BG", label: "Bulgarian", labelNative: "Български" },
  { value: "CS", label: "Czech", labelNative: "Čeština" },
  { value: "DA", label: "Danish", labelNative: "Dansk" },
  { value: "DE", label: "German", labelNative: "Deutsch" },
  { value: "EL", label: "Greek", labelNative: "Ελληνικά" },
  { value: "EN", label: "English (auto variant)", labelNative: "English" },
  { value: "EN-GB", label: "English (British)", labelNative: "English (UK)" },
  { value: "EN-US", label: "English (American)", labelNative: "English (US)" },
  { value: "ES", label: "Spanish", labelNative: "Español" },
  { value: "ET", label: "Estonian", labelNative: "Eesti" },
  { value: "FI", label: "Finnish", labelNative: "Suomi" },
  { value: "FR", label: "French", labelNative: "Français" },
  { value: "HU", label: "Hungarian", labelNative: "Magyar" },
  { value: "ID", label: "Indonesian", labelNative: "Bahasa Indonesia" },
  { value: "IT", label: "Italian", labelNative: "Italiano" },
  { value: "JA", label: "Japanese", labelNative: "日本語" },
  { value: "KO", label: "Korean", labelNative: "한국어" },
  { value: "LT", label: "Lithuanian", labelNative: "Lietuvių" },
  { value: "LV", label: "Latvian", labelNative: "Latviešu" },
  { value: "NB", label: "Norwegian (Bokmål)", labelNative: "Norsk" },
  { value: "NL", label: "Dutch", labelNative: "Nederlands" },
  { value: "PL", label: "Polish", labelNative: "Polski" },
  { value: "PT", label: "Portuguese (auto variant)", labelNative: "Português" },
  { value: "PT-BR", label: "Portuguese (Brazil)", labelNative: "Português (Brasil)" },
  { value: "PT-PT", label: "Portuguese (Portugal)", labelNative: "Português (Portugal)" },
  { value: "RO", label: "Romanian", labelNative: "Română" },
  { value: "RU", label: "Russian", labelNative: "Русский" },
  { value: "SK", label: "Slovak", labelNative: "Slovenčina" },
  { value: "SL", label: "Slovenian", labelNative: "Slovenščina" },
  { value: "SV", label: "Swedish", labelNative: "Svenska" },
  { value: "TR", label: "Turkish", labelNative: "Türkçe" },
  { value: "UK", label: "Ukrainian", labelNative: "Українська" },
  { value: "ZH", label: "Chinese (simplified)", labelNative: "简体中文" },
]);

export function pitchCustomerLangLabel(code) {
  const c = String(code ?? "")
    .trim()
    .toUpperCase();
  const o = PITCH_CUSTOMER_LANG_OPTIONS.find((x) => x.value === c);
  if (o) return `${o.label} (${o.value})`;
  return c || "—";
}

export const PITCH_NEWS_NAV_LOCALES = Object.freeze(
  [
    { code: "DA", label: "Dansk" },
    { code: "NB", label: "Norsk" },
    { code: "SV", label: "Svenska" },
  ],
);

export function pitchCustomerLangNativeLabel(code) {
  const c = String(code ?? "")
    .trim()
    .toUpperCase();
  const o = PITCH_CUSTOMER_LANG_OPTIONS.find((x) => x.value === c);
  if (o) return o.labelNative;
  return c || "—";
}